import reducre from './reducer'
import {sagas as deviceTypesSaga}  from '../components/deviceTypes/store'
const sagas=[deviceTypesSaga]
export { reducre,sagas }